import React from 'react';
import Modal from 'rc-dialog';
import classNames from 'classnames';
import { observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import {
  IModalProps,
  DialogActionType
} from '@app/src/common/store/ModalStore';
import fileUploadModalService from './FileUploadModalService';
import FileUploadItem from './FileUploadItem';
import ArrowIcon from '@app/src/assets/icons/chevron-down.svg';

import './FileUploadModal.scss';

export enum UploadFileStatus {
  UPLOADED,
  PROGRESS,
  FAILED
}

// !!!IMPORTANT: use FileUploadModalService to work with the modal

const FileUploadModal = (props: IModalProps) => {

  const handleClose = () => {
    if (!fileUploadModalService.isUploadEnded) {
      return;
    }
    fileUploadModalService.cleanUp();
    fileUploadModalService.modalIsShown = false;
    props.onClose(DialogActionType.cancel);
  };

  const handleCollapse = () => fileUploadModalService.collapsed = !fileUploadModalService.collapsed;

  const { uploadFilesMap, isUploadEnded, collapsed } = fileUploadModalService;
  return (
      <Modal
        {...props}
        mask={false}
        maskClosable={false}
        keyboard={false}
        onClose={handleClose}
        destroyOnClose={true}
        wrapClassName={classNames(
          'file-upload-modal',
          isUploadEnded && 'file-upload-modal_done'
        )}
        visible
      >
        <div className="file-upload-modal__content">
          <div className="file-upload-modal__header">
            {isUploadEnded && (
              <FormattedMessage id="gallery.upload.header.done">
                {text => (
                  <span className="file-upload-modal__header_done">{text}</span>
                )}
              </FormattedMessage>
            )}
            <FormattedMessage
              id="gallery.upload.header"
              values={{
                0: fileUploadModalService.uploadedFilesCount,
                1: uploadFilesMap.size
              }}
            />
            {!isUploadEnded && (
              <span className="file-upload-modal__header_loading">...</span>
            )}
            <button
              onClick={handleCollapse}
              className={classNames(
                'file-upload-modal__collapse-btn',
                collapsed && 'file-upload-modal__collapse-btn_collapsed'
              )}
            >
              <ArrowIcon />
            </button>
          </div>
          {!collapsed && (
            <div className="file-upload-modal__items-wrapper">
              <div className="file-upload-modal__items">
                {[...uploadFilesMap.keys()].reverse().map(fileId => (
                  <FileUploadItem
                    key={fileId}
                    uploadData={uploadFilesMap.get(fileId)}
                  />
                ))}
              </div>
            </div>
          )}
        </div>
      </Modal>
    );
};

export default observer(FileUploadModal);
